import { Link } from "react-router-dom";
import { ITAAS_INSTITUTION, publicLegalIdentifierLines } from "@itaas/pep-contracts";
import { SiteLayout } from "../components/layout/SiteLayout";
import { SeoHead } from "../components/seo/SeoHead";
import { usePepI18n } from "../i18n/usePepI18n";

export function LegalPage() {
  const { locale } = usePepI18n();
  const en = locale === "en";
  const ids = publicLegalIdentifierLines();

  return (
    <SiteLayout>
      <SeoHead
        title={en ? "Legal notice" : "Mentions légales"}
        description={
          en
            ? "Publisher identity for www.itaas-suite.com — ITaaS RDC, Lubumbashi."
            : "Identité de l’éditeur de www.itaas-suite.com — ITaaS RDC, Lubumbashi."
        }
        canonicalPath="/legal"
        locale={locale}
      />
      <div className="pep-page-hero py-5 mb-0">
        <div className="container">
          <h1 className="display-5 fw-bold mb-2">{en ? "Legal notice" : "Mentions légales"}</h1>
          <p className="lead mb-0 opacity-90">
            {en ? "Publisher of this website" : "Éditeur de ce site"}
          </p>
        </div>
      </div>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8">
            <h2 className="h5 fw-bold">{en ? "Publisher" : "Éditeur"}</h2>
            <p className="mb-1">
              <strong>{ITAAS_INSTITUTION.legalName}</strong>
            </p>
            <p className="mb-1">{en ? "Trading as" : "Enseigne"} : {ITAAS_INSTITUTION.brandName}</p>
            <p className="mb-3">
              {en ? "Publishes and operates" : "Édite et opère"}{" "}
              <strong>{ITAAS_INSTITUTION.productBrand}</strong> (
              <a href={ITAAS_INSTITUTION.productWebsite}>{ITAAS_INSTITUTION.productWebsite}</a>).
            </p>

            <h2 className="h5 fw-bold mt-4">{en ? "Registered office" : "Siège"}</h2>
            {ITAAS_INSTITUTION.address.displayLines.map((line) => (
              <p className="mb-0" key={line}>
                {line}
              </p>
            ))}

            <h2 className="h5 fw-bold mt-4">{en ? "Contact" : "Contact"}</h2>
            <p className="mb-1">
              <a href={`mailto:${ITAAS_INSTITUTION.email}`}>{ITAAS_INSTITUTION.email}</a>
            </p>
            <p className="mb-1">
              <a href={`tel:${ITAAS_INSTITUTION.telephoneTel}`}>{ITAAS_INSTITUTION.telephone}</a>
            </p>
            <p className="mb-3">
              <a href={ITAAS_INSTITUTION.institutionalWebsite} rel="noopener noreferrer">
                {ITAAS_INSTITUTION.institutionalWebsite}
              </a>
            </p>

            <h2 className="h5 fw-bold mt-4">
              {en ? "Administrative identifiers" : "Identifiants administratifs"}
            </h2>
            <ul className="small">
              {ids.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>

            <h2 className="h5 fw-bold mt-4">
              {en ? "Hosting" : "Hébergement"}
            </h2>
            <p className="small text-secondary mb-0">
              {en
                ? "Hosting provider details will be published when the contractual hosting identity is confirmed. Do not treat placeholders as legal notices."
                : "Les coordonnées de l’hébergeur seront publiées lorsque l’identité contractuelle d’hébergement sera confirmée. Aucun placeholder n’est affiché en production."}
            </p>

            <p className="mt-4 mb-0">
              <Link to="/about">{en ? "About ITaaS RDC" : "À propos d’ITaaS RDC"}</Link>
              {" · "}
              <Link to="/contact">{en ? "Contact" : "Contact"}</Link>
              {" · "}
              <Link to="/privacy">{en ? "Privacy" : "Confidentialité"}</Link>
            </p>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
